import { amount } from '@tencent/wphk-base-utils';
/** 现金券字号 */
enum AMOUNT_SIZE {
  LARGE = 1,
  MIDDLE,
  SMALL,
}
/** 现金券字号大小 */
const AMOUNT_SIZE_MAP = {
  [AMOUNT_SIZE.LARGE]: 56,
  [AMOUNT_SIZE.MIDDLE]: 44,
  [AMOUNT_SIZE.SMALL]: 32,
};

/** 根据分获取金额长度 */
export function getFen2YuanLen(prizeAmountFen: number) {
  const yuanStr = String(Number(amount.fen2Yuan(String(prizeAmountFen))));
  const len = yuanStr.length;
  return len;
}

/** 根据现金券长度获取字号 */
export function getSizeByAmountLen(len: number): number {
  if (len <= 2) {
    return AMOUNT_SIZE_MAP[AMOUNT_SIZE.LARGE];
  }
  if (len === 3) {
    return AMOUNT_SIZE_MAP[AMOUNT_SIZE.MIDDLE];
  }
  return AMOUNT_SIZE_MAP[AMOUNT_SIZE.SMALL];
}
